import React from 'react';
import styled from 'styled-components';

import icon from '../assets/icons/loader-dark.svg'

const StyledComponent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4rem 0;
    text-align: center;
    .icon {
        width: 24px;
        height: 24px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .label {
        margin-top: 1rem;
        color: var(--gray-regular);
        font-size: 1.2rem;
    }
`

const Component = () => {
    return (
        <StyledComponent>
            <div className="icon">
                <img src={icon} alt=""/>
            </div>
            <div className="label">Cargando</div>
        </StyledComponent>
    )
}

export default Component;